import { useState } from "react";
import BaseSection from "../BaseSection";
import {
  Container,
  RequiredFieldInput,
  RequiredFieldLabel,
  RequiredFieldsContainer,
  RequiredFieldsText,
  Title,
} from "./styles";
import { alwaysRequiredUserFieldIDs, SURVEY_CONFIG_FIELDS, SURVEY_FORM_FIELDS, userFieldsOptions } from "../../../constants";

export default function UserInfoSection({ values, onChangeValue }) {
  const defaultConfig = {
    [SURVEY_CONFIG_FIELDS.USER_INPUTS]: values[SURVEY_FORM_FIELDS.CONFIG]?.[SURVEY_CONFIG_FIELDS.USER_INPUTS] || alwaysRequiredUserFieldIDs
  }

  const [config, setConfig] = useState(defaultConfig);
  const [isEditting, setIsEditting] = useState(false);

  const handleChangeUserInputs = (value) => {
    const oldUserInputs = [...config[SURVEY_CONFIG_FIELDS.USER_INPUTS]];
    let newUserInputs = [];

    if(oldUserInputs.includes(value)) {
      newUserInputs = oldUserInputs.filter(input => input !== value);
    } else {
      newUserInputs = [...oldUserInputs, value]
    }

    setConfig(prev => {
      return {
        ...prev,
        [SURVEY_CONFIG_FIELDS.USER_INPUTS]: newUserInputs
      }  
    });
  }

  const handleSubmit = () => {
    onChangeValue(SURVEY_FORM_FIELDS.CONFIG, config);
    toggleIsEditting();
  }

  const toggleIsEditting = () => {
    setIsEditting(prev => !prev);
  }

  const handleCancelEditting = () => {
    setConfig(defaultConfig);
    toggleIsEditting();
  }

  return (
    <BaseSection
      allowEdit
      isEditting={isEditting}
      onToggleIsEditting={toggleIsEditting}
      onSubmitEditting={handleSubmit}
      onCancelEditting={handleCancelEditting}
    >
      <Container>
        <Title>Informações Pessoais</Title>
        <RequiredFieldsContainer>
          <RequiredFieldsText title="Marca quais dados serão coletados do usuário na pesquisa">Entradas do usuário: </RequiredFieldsText>
          {userFieldsOptions.map((field) => {
            const alwaysChecked = alwaysRequiredUserFieldIDs.includes(
              field.value
            );
            const disabled = alwaysChecked || !isEditting;

            return (
              <RequiredFieldLabel aria-disabled={disabled} key={field.value}>
                <RequiredFieldInput
                  type="checkbox"
                  name="user-field"
                  checked={config?.[SURVEY_CONFIG_FIELDS.USER_INPUTS]?.includes(field.value)}
                  disabled={disabled}
                  value={field.value}
                  onChange={(e) => handleChangeUserInputs(field.value, e.target.value)}
                />
                <span>{field.label}</span>
              </RequiredFieldLabel>
            );
          })}
        </RequiredFieldsContainer>
      </Container>
    </BaseSection>
  );
}
